module.exports = __webpack_public_path__ + "static/Portait-6353bac2e7eef81f4abe2c9d37ad1116.jpg";